<template>
    <div class="body-vas-amarillo">
        <top-bar-sub-entel-cocina/>
        <div class="site-content" v-show="isVisible">
            <div class="container">
                <div class="row justify-content-center">
                    <div
                        :class="'col-md-6 p-0'"
                        :style="{
                    'max-width': '500px' ,
                    'margin':'auto'
                    }"
                    >
                        <h5 class="text-morado checkout-title-primary-lp font-weight-light text-center landing-vas-title"> ¿Quieres comer más sano pero <b>no sabes qué preparar?</b></h5>
                        <div class="imagen-main-vas">
                            <img class="img-fluid w-100" :src=imagen alt="">
                                <div class="imagen-main-vas-contenido">
                                    <h2>Aprende las recetas saludables <span>más deliciosas</span></h2>
                                <div class="checkout-card-lp" v-if="disabledForm == 1">
                                    <div class="border-0">
                                        <div>
                                            <div v-if="fe">
                                                <form @submit.prevent="entelSubscribe"
                                                      v-if="visibleSuscribirFe == 2"
                                                      ref="registro-form-form"
                                                      :class="{'validated': validated}"
                                                      novalidate>
                                                    <div v-if="!cuentaCreada" class="formulario-suscripcion-lp">
                                                        <div class="form-group" v-if="visibleInput == 0">
                                                            <div class="text-center">
                                                                <label class="label-lp text-white">Ingrese su número de teléfono</label>
                                                            </div>
                                                            <input
                                                                type="number"
                                                                :disabled="disabledInput == 1"
                                                                :class="{
                                            'form-control': true,
                                            'form-control-lp': true,
                                            'is-invalid': validated && (telefono == '' || !isTelefonoValid),
                                            'is-valid': validated && isTelefonoValid && telefono != ''
                                        }"
                                                                name="email"
                                                                id="registro-form-telefono-landing"
                                                                aria-describedby="telefonoHelp"
                                                                placeholder="     Ej: 912345678"
                                                                autocomplete="off"
                                                                v-model="telefono"
                                                                required
                                                            />
                                                            <div class="invalid-feedback">Teléfono inválido</div>
                                                            <div class="valid-feedback" v-if="validated"></div>
                                                        </div>

                                                        <div class="text-center">
                                                            <button
                                                                id="btn-suscribirse"
                                                                class="btn-lp checkout-pay btn-suscribirse-lp checkout-pay-lp btn-big gtm-registro-header btn-azul-entel"
                                                                style="max-width:100%"
                                                                :disabled="suscrib">
                                                                SUSCRÍBETE
                                                            </button>
                                                        </div>
                                                        <br/>
                                                        <div class="perfil-alert color-red" v-if="alert.visible">
                                                            <font-awesome-icon
                                                                :icon="alert.icon"
                                                                class="color-red"
                                                                :class="{
                                    spin: alert.iconSpin
                                }"
                                                            />
                                                            {{ alert.message }}
                                                        </div>
                                                    </div>
                                                    <div v-else class="text-center alert-text-box">
                                                        <p>Activa tu cuenta desde el link que hemos enviado a tu correo</p>
                                                    </div>
                                                </form>
                                                <form @submit.prevent="tokenEmpello"
                                                      v-if="visibleSuscribirFe == 3"
                                                      ref="registro-form-form"
                                                      :class="{'validated': validated}"
                                                      novalidate>
                                                    <div v-if="!cuentaCreada" class="formulario-suscripcion-lp">
                                                        <div class="form-group">
                                                            <div class="invalid-feedback">Teléfono inválido</div>
                                                            <div class="valid-feedback" v-if="validated"></div>
                                                        </div>
                                                        <div class="text-center">
                                                            <button
                                                                id="btn-confirmar"
                                                                class="btn btn-primary checkout-pay btn-suscribirse-lp checkout-pay-lp btn-big gtm-registro-header btn-verde-lp"
                                                                style="max-width:100%"
                                                                @click="entelConfirmar">
                                                                CONFIRMAR SUSCRIPCIÓN
                                                            </button>
                                                        </div>
                                                        <br/>
                                                        <div class="perfil-alert color-red" v-if="alert.visible">
                                                            <font-awesome-icon
                                                                :icon="alert.icon"
                                                                class="color-red"
                                                                :class="{
                                    spin: alert.iconSpin
                                }"
                                                            />
                                                            {{ alert.message }}
                                                        </div>
                                                    </div>
                                                    <div v-else class="text-center alert-text-box">
                                                        <p>Activa tu cuenta desde el link que hemos enviado a tu correo</p>
                                                    </div>
                                                </form>
                                            </div>
                                            <div v-else>
                                                <form @submit.prevent="entelSubscribe"
                                                      v-if="visibleSuscribirFe == 2"
                                                      ref="registro-form-form"
                                                      :class="{'validated': validated}"
                                                      novalidate>
                                                    <div v-if="!cuentaCreada">
                                                        <div class="form-group" v-if="visibleInput == 0">
                                                            <br/>
                                                            <input
                                                                type="number"
                                                                :disabled="disabledInput == 1"
                                                                :class="{
                                            'form-control': true,
                                            'form-control-lp': true,
                                            'is-invalid': validated && (telefono == '' || !isTelefonoValid),
                                            'is-valid': validated && isTelefonoValid && telefono != ''
                                        }"
                                                                name="email"
                                                                id="registro-form-telefono-landing"
                                                                aria-describedby="telefonoHelp"
                                                                placeholder="Ej: 912345678"
                                                                autocomplete="off"
                                                                v-model="telefono"
                                                                required
                                                            />
                                                            <div class="invalid-feedback">Teléfono inválido</div>
                                                            <div class="valid-feedback" v-if="validated"></div>
                                                        </div>
                                                        <div class="text-center">
                                                            <button
                                                                id="btn-suscribirse"
                                                                class="btn-lp checkout-pay btn-suscribirse-lp checkout-pay-lp btn-big gtm-registro-header btn-azul-entel"
                                                                style="max-width:100%"
                                                                :disabled="suscrib">
                                                                SUSCRÍBETE
                                                            </button>
                                                        </div>
                                                        <br/>
                                                        <div class="perfil-alert color-red" v-if="alert.visible">
                                                            <font-awesome-icon
                                                                :icon="alert.icon"
                                                                class="color-red"
                                                                :class="{
                                    spin: alert.iconSpin
                                }"
                                                            />
                                                            {{ alert.message }}
                                                        </div>
                                                    </div>
                                                    <div v-else class="text-center alert-text-box">
                                                        <p>Activa tu cuenta desde el link que hemos enviado a tu correo</p>
                                                    </div>
                                                </form>
                                                <form @submit.prevent="tokenEmpello"
                                                      v-if="visibleSuscribirFe == 3"
                                                      ref="registro-form-form"
                                                      :class="{'validated': validated}"
                                                      novalidate>
                                                    <div v-if="!cuentaCreada">
                                                        <div class="form-group">
                                                            <div class="invalid-feedback">Teléfono inválido</div>
                                                            <div class="valid-feedback" v-if="validated"></div>
                                                        </div>
                                                        <div class="text-center">
                                                            <button
                                                                id="btn-confirmar"
                                                                class="btn btn-primary checkout-pay btn-suscribirse-lp checkout-pay-lp btn-big gtm-registro-header btn-verde-lp"
                                                                style="max-width:100%"
                                                                @click="entelConfirmar">
                                                                CONFIRMAR SUSCRIPCIÓN
                                                            </button>
                                                        </div>
                                                        <br/>
                                                        <div class="perfil-alert color-red" v-if="alert.visible">
                                                            <font-awesome-icon
                                                                :icon="alert.icon"
                                                                class="color-red"
                                                                :class="{
                                spin: alert.iconSpin
                            }"
                                                            />
                                                            {{ alert.message }}
                                                        </div>
                                                    </div>
                                                    <div v-else class="text-center alert-text-box">
                                                        <p>Activa tu cuenta desde el link que hemos enviado a tu correo</p>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </div>
                        </div>
                        <div class="text-center p-2 vas-terminos text-gris">
                            <label class="label-lp">Precio $990 (IVA Incl.)<br>Renovación automática semanal. <br><br><b>Importante:</b>  La suscripción a este
                                servicio representa un cobro
                                adicional con cargo a tu boleta o
                                saldo Entel. <br><br> Para desuscribir, envía SALIR al 2488</label><br>
                            <a @click="condiciones"><u>Términos y Condiciones</u></a>
                        </div>
                </div>
            </div>
        </div>
        <b-modal v-model="modalPinInputPin"
                 :busy="true"
                 centered
                 hide-footer
                 v-bind:title="Algo">
            <div class="form-group text-center">
                <br>
                <label class="label-movistar">Te enviamos un mensaje <b>SMS a tu número +{{telefono}}</b> con un <b>Código PIN</b> para que puedas confirmar tu suscripción</label>
                <br>
                <label class="label-movistar"></label>
                <div class="row formulario-suscripcion-lp">
                    <div class="form form-input">
                        <div class="form-group">
                            <input
                                v-model="pin"
                                class="form-control form-control-lp text-center center-input"
                                type="text"
                                maxlength="12"
                                placeholder="Ingresar Código PIN"
                                ref="pin"
                            />
                        </div>

                        <div class="col">
                            <button
                                :class="'btn btn-primary checkout-pay btn-suscribirse-lp checkout-pay-lp btn-big gtm-registro-header btn-verde-lp'"
                                style="max-width:100%"
                                @click="tokenEmpello">
                                CONFIRMAR SUSCRIPCIÓN
                            </button>
                        </div>
                        <br/>
                        <div
                            class="text-center alert-text-box"
                            :class="{
                         'color-red': !colorMensajePin ,
                         'color-green': colorMensajePin
                         }"
                            v-if="pinMessage != ''"
                        >{{ pinMessage }}
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
        <b-modal v-model="modalFelicitaciones"
                 :busy="true"
                 centered
                 hide-footer
                 v-bind:title="Algo">
            <div class="form-group text-center">
                <br>
                <label class="label-movistar">Muchas gracias por su registro, en un momento será redireccionado.</label>
                <br>
                <label class="label-movistar"></label>
            </div>
        </b-modal>
        <b-modal v-model="modalCondiciones"
                 :busy="true"
                 centered
                 hide-footer
                 v-bind:title="Algo">
            <div class="form-group text-center">
                <h2><u><b>Términos y Condiciones</b></u></h2>
                <br>
                <label class="label-movistar">El valor de la suscripción o servicio
                    contratado, será cobrado en la boleta
                    Entel correspondiente al periodo de
                    consumo y de forma adicional al cargo
                    fijo del plan. En caso de clientes prepago,
                    el valor se descontará inmediatamente
                    del saldo disponible.</label>
                <br>
            </div>
        </b-modal>
        <b-modal v-model="modalMomento"
                 :busy="true"
                 centered
                 hide-footer
                 v-bind:title="Suscribirse">
            <div class="form-group text-center">
                <div class="loading-spinner-container">
                    <div class="loading-spinner"></div>
                </div>
            </div>
        </b-modal>
        <b-modal v-model="modalError"
                 :busy="true"
                 centered
                 hide-footer>
            <div class="form-group text-center">
                <br>
                <div style="text-align: center">
                    <img
                        :src="require('@/assets/errores/003.png')"
                        alt
                    />
                </div>
                <br>
                <div
                    class="label-movistar"
                    v-html="mensajeError"
                ></div>
                <br>
                <br>
                <div class="col">
                    <button
                        v-if="errorDesbloqueo"
                        :class="'btn btn-primary checkout-pay '"
                        style="border-radius: 8px"
                        @click="entelDesbloqueo">
                        <b style="color: white">DESBLOQUEAR CATEGORÍA</b>
                    </button>
                </div>
                <div class="col">
                    <button
                        v-if="errorBoton"
                        :class="'btn btn-primary checkout-pay '"
                        style="border-radius: 8px"
                        @click="cerrar">
                        <b style="color: white">{{ textoBoton }}</b>
                    </button>
                </div>
            </div>
        </b-modal>
        <b-modal v-model="modalErrorExt"
                 :busy="true"
                 centered
                 hide-footer>
            <div class="form-group text-center">
                <br>
                <div style="text-align: center">
                    <img
                        :src="require('@/assets/errores/003.png')"
                        alt
                    />
                </div>
                <br>
                <div
                    class="label-movistar"
                    v-html="mensajeError"
                ></div>
                <br>
                <br>
                <div class="col">
                    <button
                        v-if="errorBotonVuelInt"
                        :class="'btn btn-primary checkout-pay '"
                        style="border-radius: 8px"
                        @click="vuelveIntentar">
                        <b style="color: white">{{ textoBoton }}</b>
                    </button>
                </div>
                <div class="col">
                    <button
                        v-if="errorBotonObtCod"
                        :class="'btn btn-primary checkout-pay '"
                        style="border-radius: 8px"
                        @click="cerrar">
                        <b style="color: white">{{ textoBoton }}</b>
                    </button>
                </div>
            </div>
        </b-modal>
        <b-modal v-model="modalErrorEntelInfo"
                 :busy="true"
                 centered
                 hide-footer>
            <div class="form-group text-center">
                <br>
                <br>
                <div
                    class="label-movistar"
                    v-html="mensajeError"
                ></div>
                <br>
            </div>
        </b-modal>
    </div>
    </div>
</template>
<style scoped>
body {
    background-color: white;
}
</style>
<script>
import bModal from "bootstrap-vue/es/components/modal/modal";
import bModalDirective from "bootstrap-vue/es/directives/modal/modal";
import TransferenciaForm from "../components/TransferenciaForm";
import CencosudForm from "../components/CencosudForm";
import TopBar from "../components/TopBar";
import TopBarSubEntel from "../components/TopBarSubEntel.vue";
import TopBarSubEntelCocina from "./TopBarSubEntelCocina.vue";
import SiteFooter from "../components/SiteFooter";
import Spinner from "../components/Spinner";
import {isValidEmail, isValidTelefono, rutEsValido} from "../utilities/util";
import BlockStatic from "../components/BlockStatic";
import numeral from "numeral";
import "numeral/locales";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
numeral.locale("es");
import axios from 'axios';

export default {
    name: "LpEntel",
    components: {
        TopBar,
        TopBarSubEntel,
        TopBarSubEntelCocina,
        bModal,
        TransferenciaForm,
        CencosudForm,
        SiteFooter,
        Spinner,
        BlockStatic,
        FontAwesomeIcon,
    },
    directives: {
        "b-modal": bModalDirective,
    },
    computed: {
        isTelefonoValid() {
            if (this.telefono.length == 9) {
                return isValidTelefono(this.telefono.toString());
            }else {
                return false;
            }
        },
    },
    watch: {

    },
    data() {
        return {
            visibleSuscribirFe: 2,
            imagen: require('@/assets/galerias/imagen_vas_cocina_2.jpg'),
            imagenArriba: require('@/assets/galerias/bg_vas_cocina.svg'),
            modalCondiciones: false,
            suscrib: false,
            empello: "",
            errorBotonVuelInt: false,
            errorBotonObtCod: false,
            producto: "",
            disabledInput: 0,
            disabledForm: 1,
            visibleInput: 1,
            prepago: false,
            pospago: false,
            modalMomento: false,
            inscriptionId: "",
            pinMessage: "",
            colorMensajePin: false,
            pin: "",
            modalPinInputPin: false,
            modalError: false,
            descripcion_operador: "",
            descripcion: "Aca va la descripcion del curso",
            isVisible: false,
            validated: false,
            isSubmitting: false,
            cuentaCreada: false,
            telefono: JSON.parse(window.sessionStorage.getItem('telefono')),
            telefono_suscribir: "",
            alert: {
                message: "",
                visible: false,
                icon: "",
                iconSpin: false,
            },
            productId: this.$route.params.productId,
            tid: "",
            fe: this.$route.query.fe,
            entryChannel: "",
            service_ip_entel: "",
            modalFelicitaciones: false,
            mensajeError: "",
            statusError: "",
            msisdn: "",
            ip: "",
            schar: "",
            errorBoton: false,
            errorDesbloqueo: false,
            textoBoton: "",
            modalErrorEntelInfo: false,
            paramenviar: "",
            valueHeader: this.$route.query.valueHeader === "1" ? true : false,
            error: this.$route.query.error,
        };
    },
    methods: {
        play(){
            this.visibleSuscribirFe = 2;
        },
        playImg(){
            this.visibleSuscribirFe = 2;
        },
        condiciones(){
            this.modalCondiciones = true;
        },
        cerrar(){
            this.suscrib = false;
            this.textoBoton = "";
            this.mensajeError = "";
            this.isSubmitting = false;
            this.validated = false;
            this.modalError = false;
            this.modalPinInputPin = false;
            this.errorBoton = false;
            this.errorDesbloqueo = false;
            this.modalErrorExt = false;
            if (this.telefono !== "") {
                this.disabledInput = 1;
            }
        },
        activarSuscribirFe(){
            this.visibleSuscribirFe = 2;
        },
        vuelveIntentar(){
            this.modalErrorExt = false;
            if (this.entryChannel === "WEB") {
                this.modalPinInputPin = true;
            }
        },
        async entelInfo(){
            await this.$api
                .entelInfo({
                    userIdentifier: this.telefono,
                    productId: this.productId,
                })
                .then((response) => {
                    if (response.data.dailyCap === true || response.data.error === false) {
                        this.modalErrorEntelInfo = true;
                        setTimeout(() => {
                            this.modalErrorEntelInfo = false;
                        }, 3000);
                    } else {
                        if (response.data.planType === "0" && response.data.error === true) {
                            this.prepago = true;
                            this.descripcion_operador = "Precio $990 (IVA Incl.) renovación automática semanal. Servicio de suscripción con renovación automática. Precio con cobro al saldo disponible, se aplica mientras no se cancele suscripción. Para cancelar envía SALIR al 2488. Revisar Términos y Condiciones aqui"
                        } else if (response.data.planType !== "0" || (response.data.error === true && response.data.planType === "" && response.data.dailyCap === "")) {
                            this.pospago = true;
                            this.descripcion_operador = "Precio $990 (IVA Incl.) renovación automática semanal. Servicio de suscripción con renovación automática. Precio con cobro adicional al cargo fijo del plan, se aplica mientras no se cancele suscripción. Para cancelar envía SALIR al 2488. Revisar Términos y Condiciones aqui"
                        }
                    }
                });
        },
        async headerReq1(){
            this.msisdn =this.$route.query.msisdn;
            this.ip = this.$route.query.ip;
            this.schar = this.$route.query.schar;
            await this.$api
                .hearderReq1({
                    msisdn: this.msisdn,
                    ip: this.ip,
                    schar: this.schar,
                })
                .then((response) => {
                    if (response.data.message === "success") {
                        this.telefono = response.data.msisdn;
                        this.inscribedByMobile()
                        this.modalMomento = false;
                    } else {
                        if (this.fe) {
                            this.visibleInput = 0;
                        }
                        if (!this.fe)
                            this.disabledForm = 1;
                        this.isVisible = true;
                        this.prepago = true;
                        this.descripcion_operador = "Precio $990 (IVA Incl.) renovación automática semanal. Servicio de suscripción con renovación automática. Precio con cobro adicional al cargo fijo del plan o contra el saldo disponible, se aplica mientras no se cancele suscripción. Para cancelar envía SALIR al 2488. Revisar Términos y Condiciones aqui";
                        this.entryChannel = "WEB";
                        this.modalMomento = false;
                        this.entelSubscribe();
                    }
                });
        },
        hearderReqDatos(){
            this.$api
                .hearderReqDatos()
                .then((response) => {
                    if (response.data.msisdn !== "") {
                        window.location.href = "https://topclass.cl/lp/entel/" + this.productId + "?tid=" + this.tid + "&msisdn=" + response.data.msisdn + "&ip=" + response.data.ip + "&schar=" + response.data.schar + "&status=1";
                    }else {
                        if (this.fe){
                            window.location.href = "https://topclass.cl/lp/entel/" + this.productId + "?tid=" + this.tid + "&fe=" + this.fe+ "&status=1";
                        }else {
                            window.location.href = "https://topclass.cl/lp/entel/" + this.productId + "?tid=" + this.tid + "&status=1";
                        }
                    }
                    /*if (response.data.msisdn !== "") {
                        window.location.href = "http://topclass.test/lp/entel/" + this.productId + "?tid=" + this.tid + "&msisdn=" + response.data.msisdn + "&ip=" + response.data.ip + "&schar=" + response.data.schar + "&status=1";
                    }else {
                        if (this.fe){
                            window.location.href = "http://topclass.test/lp/entel/" + this.productId + "?tid=" + this.tid + "&fe=" + this.fe+ "&status=1";
                        }else {
                            window.location.href = "http://topclass.test/lp/entel/" + this.productId + "?tid=" + this.tid + "&status=1";
                        }
                    }*/
                });
        },
        async datosProducto(){
            await this.$api
                .datosProducto({productId: this.productId})
                .then((response) => {
                    if (response.data.success === true) {
                        this.producto = response.data.producto;
                        /*this.empello = response.data.empello;
                        //Agregando EMPELLO FRAUDSTOOP
                        let empelloFraudStop = document.createElement("script");
                        empelloFraudStop.setAttribute(
                            "src",
                            "//" + this.empello
                        );
                        document.head.appendChild(empelloFraudStop);*/
                    }
                });
        },
        entelConfirmar(){
            this.errorDesbloqueo = false;
            this.pinMessage = "";
            this.$log.warn('Entel Confirmar');
            this.$api
                .entelConfirmar({
                    entryChannel: (this.entryChannel === "WAP" ? this.entryChannel : this.entryChannel = "WEB"),
                    inscriptionId: this.inscriptionId,
                    pin: this.pin,
                    empelloToken: this.empello,
                })
                .then((response) => {
                    if (response.data.success ===true && (response.data.status === 201 || response.data.status === 200)){
                        if (this.productId === "1000007078"){
                            this.$router.push({
                                name: "LpEntelFelicitaciones",
                                params: {
                                    msisdn: "56" + this.telefono,
                                }
                            });
                            //window.location.href = "/felicitaciones/lp/entel?msisdn=56"+ this.telefono
                        }else {
                            this.modalFelicitaciones = true;
                            setTimeout(() => {
                                this.proxyUser();
                            }, 4000);
                        }
                    }else if(response.data.status === 1 || response.data.status === 2){
                        this.modalPinInputPin = false;
                        this.errorDesbloqueo =true;
                        this.mensajeError = response.data.message;
                        this.modalError = true;
                    }else if (response.data.status === 3 || response.data.status === 11){
                        this.modalPinInputPin = false;
                        this.errorBoton = false;
                        this.mensajeError = response.data.message;
                        this.modalError = true;
                    }else if (response.data.status === 15){
                        this.textoBoton = "OBTENER NUEVO CÓDIGO";
                        this.modalErrorExt = true;
                        this.errorBotonObtCod = true;
                        this.errorBotonVuelInt = false;
                        this.modalPinInputPin = false;
                        this.mensajeError = response.data.message;
                    }else {
                        this.textoBoton = "CERRAR";
                        this.mensajeError = response.data.message;
                        this.modalError = true;
                        this.errorBoton = true;
                        this.modalPinInputPin = false;
                    }
                });
        },
        entelDesbloqueo(){
            this.$api
                .entelDesbloqueo({
                    inscriptionId: this.inscriptionId,
                })
                .then((response) => {
                    if (response.data.status === 200){
                        this.disabledInput =1;
                        this.modalError = false;
                        this.suscrib = false;
                        //Agregando EMPELLO FRAUDSTOOP
                        let empelloFraudStop = document.createElement("script");
                        empelloFraudStop.setAttribute(
                            "src",
                            "//" + this.empello
                        );
                        document.head.appendChild(empelloFraudStop);
                    }else {
                        this.suscrib = false;
                        this.errorDesbloqueo = false;
                        this.mensajeError = response.data.message;
                        this.telefono ="";
                    }
                });
        },
        inscribedByMobile(){
            this.$api
                .inscribedByMobile({
                    mobile: this.telefono,
                })
                .then((response) => {
                    if (response.data[0]){
                        this.telefono = this.telefono.substring(2,11);
                        this.proxyUser()
                    }else {
                        this.isVisible = true;
                        window.sessionStorage.setItem('telefono', JSON.stringify(this.telefono));
                        this.telefono = this.telefono.substring(2,11);
                        this.disabledInput = 1;
                        this.disabledForm = 1;
                        this.entelInfo();
                        this.entryChannel = "WAP";
                    }
                });
        },
        async entelSubscribe(){
            if (this.entryChannel === "WEB" && this.productId === "1000007078" && !this.fe){
                this.$api
                    .true_or_false()
                    .then((response) => {
                        if (response.data.valor === 1){
                            window.location.href = "https://suscripciones.multinetlabs.com/suscripciones-ws/rest/util/proxy_pass?hash="+ this.tid
                        }else {
                            this.fe = 1;
                            this.visibleInput = 0;
                        }
                    });
            }else {
                this.validated = true;
                this.errorDesbloqueo = false;

                if (this.isTelefonoValid && this.telefono != '') {
                    this.modalMomento = true;
                    await this.$api
                        .entelSubscribe({
                            productId: this.productId,
                            tid: this.tid,
                            telefono: this.telefono,
                            entryChannel: (this.entryChannel === "WAP" ? this.entryChannel : this.entryChannel = "WEB"),
                        })
                        .then((response) => {
                            this.inscriptionId = response.data.inscriptionId;
                            /*if (!this.fe) {
                                this.visibleSuscribirFe = 3;
                            }*/
                            if (response.data.success === true && response.data.status === 200) {
                                if (this.entryChannel !== "WAP") {
                                    this.suscrib = true;
                                    this.modalPinInputPin = true;
                                    this.modalMomento = false;
                                } else {
                                    this.visibleSuscribirFe = 3;
                                    this.suscrib = true;
                                    this.isSubmitting = true;
                                    this.modalMomento = false;
                                }
                            } else if (response.data.status === 1 || response.data.status === 2) {
                                this.modalMomento = false;
                                this.errorDesbloqueo = true;
                                this.mensajeError = response.data.message;
                                this.modalError = true;
                            } else if (response.data.status === 3) {
                                this.modalMomento = false;
                                this.errorBoton = false;
                                this.mensajeError = response.data.message;
                                this.modalError = true;
                            } else if (response.data.status === 15) {
                                this.modalMomento = false;
                                this.textoBoton = "OBTENER NUEVO CÓDIGO";
                                this.modalErrorExt = true;
                                this.errorBotonObtCod = true;
                                this.errorBotonVuelInt = false;
                                this.mensajeError = response.data.message;
                            } else {
                                this.modalMomento = false;
                                this.textoBoton = "CERRAR";
                                this.errorBoton = true;
                                this.mensajeError = response.data.message;
                                this.modalError = true;
                            }
                        });
                    this.modalMomento = false;
                }
            }
        },
        async ejecutarCodigo(dataScript) {
            try {
                // Crear un nuevo elemento script
                const script = document.createElement('script');
                script.textContent = dataScript;

                // Agregar el script al head de la página
                document.head.appendChild(script);
                var self = this;
                EmpelloInterface.onFraudStopLoaded(function (statusCode)  {
                    if (statusCode === 101) {
                        // main JS loaded successfully
                    } else if (statusCode === 201 || statusCode === 200) {
                        // Checks completed, journey can continue
                        if (!self.valueHeader) {
                            self.entelConfirmar();
                        }
                    } else if (statusCode === 202) {
                        // There was an error
                        self.modalMomento = false;
                        self.mensajeError = "Ha ocurrido un error, por favor intente nuevamente."
                        self.modalError = true;
                        setTimeout(() => {
                            self.modalError = false;
                        }, 3000);
                    } else if (statusCode === 203) {
                        // The JS function timed out
                        self.modalMomento = false;
                        self.mensajeError = "Ha ocurrido un error, por favor intente nuevamente."
                        self.modalError = true;
                        setTimeout(() => {
                            self.modalError = false;
                        }, 3000);
                    }
                });
                console.log("Código ejecutado correctamente");
            } catch (error) {
                console.error("Error al ejecutar el código:", error);
            }
        },
        async tokenEmpello(){
            //let empelloToken = "";
            //empelloToken = await this.getEmepelloToken();
            this.$api
                .empelloToken({
                    telefono: this.telefono,
                    producto: this.producto
                })
                .then((response) => {
                    this.$log.warn('token empello ', response);
                    this.ejecutarCodigo(response.data.jsstring);
                    this.empello = response.data.token;
                    if (response.status === 101) {
                        // main JS loaded successfully
                    }
                    else if (response.status === 200 || response.status === 201) {
                        // Checks completed, journey can continue
                        //this.entelConfirmar();
                    }
                    else if (response.status === 202) {
                        // There was an error
                    }
                    else if (response.status === 203) {
                        // The JS function timed out
                    }
                });
        },
        proxyUser(){
            window.location.href = "https://cms.topclass.academy/thinkific/auth?msisdn=56"+ this.telefono
        },
        getEmepelloToken() {
            return new Promise((resolve, reject) => {
                Empello.getToken(function (token) {
                    resolve(token);
                });
            });
        },
        async proxyNotification() {
            this.paramenviar = window.location.search;
            await this.$api
                .proxyNotification({
                    paramenviar: this.paramenviar,
                })
                .then((response) => {
                    if (response.data.tid) {
                        this.tid = response.data.tid;
                        /*if (this.fe){
                            window.location.href = "http://topclass.test/lp/entel/" + this.productId + "?tid=" + this.tid + "&fe=" + this.fe;
                        }else {
                            window.location.href = "http://topclass.test/lp/entel/" + this.productId + "?tid=" + this.tid;
                        }*/
                        if (location.protocol === 'https:'){
                            this.$log.warn('Redireccionando a http');
                            if (this.fe){
                                window.location.href = "http://api.topclass.cl/api/hearderReqDatos?productId=" + this.productId + "&producto=" + this.producto + "&tid=" + this.tid + "&fe=" + this.fe;
                            }else {
                                window.location.href = "http://api.topclass.cl/api/hearderReqDatos?productId=" + this.productId + "&producto=" + this.producto + "&tid=" + this.tid;
                            }
                        }
                    }
                });
        },
    },
    mounted() {
        if (this.$route.query.status === "1" && this.valueHeader && this.error === "0"){
            this.empello = this.$route.query.token;
            this.datosProducto();
            this.headerReq1();
        }else if (this.$route.query.status === "1" && this.error === "0"){
            this.datosProducto();
            this.modalMomento = true;
            this.headerReq1();
        }else if (this.error === "1"){
            this.headerReq1();
            this.mensajeError = "Ha ocurrido un error intentelo más tarde";
            this.modalError = true;
        }
    },
    created() {
        if (!this.$route.query.tid) {
            this.datosProducto();
            this.proxyNotification();
        }else {
            this.tid = this.$route.query.tid;
            if (location.protocol === 'https:'){
                if (this.$route.query.status !== "1"){
                    if (this.fe){
                        window.location.href = "http://api.topclass.cl/api/hearderReqDatos?productId=" + this.productId + "?tid=" + this.tid + "&fe=" + this.fe;
                    }else {
                        window.location.href = "http://api.topclass.cl/api/hearderReqDatos?productId=" + this.productId + "?tid=" + this.tid;
                    }
                }
            }
        }
        /*if (this.productId === "1000007090" && this.$route.query.operador) {
            this.proxyNotification();
        }else {
            this.tid = this.$route.query.tid;
            if (this.$route.query.status !== "1"){
                if (location.protocol === 'https:'){
                    if (this.fe){
                        window.location.href = "http://topclass.test/lp/entel/" + this.productId + "?tid=" + this.tid + "&fe=" + this.fe;
                    }else {
                        window.location.href = "http://topclass.test/lp/entel/" + this.productId + "?tid=" + this.tid;
                    }
                }
                this.hearderReqDatos();
            }
        }*/
    },
};
</script>
